import React, { useState } from 'react';
import './../style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faLock } from '@fortawesome/fontawesome-free-solid';
import { LOGIN } from 'global/routes';
import { InputText, KCSModal, Notification, InputRadio } from 'components';
import { Button } from 'react-bootstrap';
import { UserService } from 'services/UserService';
import { FormattedMessage, useIntl } from 'react-intl';
import telephone from 'assets/imgs/telephone_2.png';
import ResetPassword from './ResetPassword';

const regexPhoneNumber = /(84|0[3|5|7|8|9])+([0-9]{8})\b/g;
const regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])\S{6,22}$/;
const md5Hex = require('md5-hex');

const Signup = ({ history, closeModalLogin }) => {
  const [step, setStep] = useState(0);
  const [otp, setOtp] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [rePassword, setRePassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [errorMsg2, setErrorMsg2] = useState('');
  const [term, setTerm] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const [content, setContent] = useState('');

  const [newPassword, setNewPassword] = useState('');
  const [renewPassword, setRenewPassword] = useState('');

  const intl = useIntl();

  const handleRePassword = (value) => {
    setRePassword(value);
    if (password !== value) {
      setErrorMsg2(intl.formatMessage({ id: 'IDS_TV_PASSWORD_NOT_MATCH' }));
    } else {
      setErrorMsg2('');
    }
  }

  const handlePassword = (value) => {
    setPassword(value);
    if (!regexPassword.test(value)) {
      setErrorMsg(intl.formatMessage({ id: 'IDS_NOTICE_PASS' }));
    } else {
      setErrorMsg('');
    }
    if (rePassword && rePassword !== value) {
      setErrorMsg2(intl.formatMessage({ id: 'IDS_TV_PASSWORD_NOT_MATCH' }));
    } else {
      setErrorMsg2('');
    }
  }

  const handleRegister = () => {
    const data = {
      pin: otp,
      msisdn: phoneNumber,
      password: md5Hex(password),
    };

    UserService.register(data, res => {
      if (res.error_code === '0') {
        Notification.success(intl.formatMessage({ id: 'IDS_TV_DANG_KY_THANH_CONG' }));
        closeModalLogin();
        history.push(LOGIN);
      } else {
        setOpenModal(true);
        setContent(res.message || intl.formatMessage({ id: 'IDS_REGISTER_FAILED' }));
      }
    });
  }

  const validPassword = () => {
    if (!password || !rePassword || password !== rePassword || errorMsg || errorMsg2) {
      return false;
    }
    return true;
  }

  const isDisabled = () => {
    return errorMsg || phoneNumber.length === 0;
  }

  const isDisabledRegister = () => {
    return !otp || !validPassword();
  }

  // const onBack = () => {
  //   setStep(0);
  //   setOtp('');
  //   setPassword('');
  //   setRePassword('');
  //   setTerm(false);
  // }

  const sendOTP = (isForgotPassword) => {
    const data = {
      msisdn: phoneNumber,
      otp_service: isForgotPassword === true ? "authen_miss_password" :
        "authen_register,payment_wallet_register"
    };

    UserService.sendOTP(data, res => {
      if (res.error_code === '0') {
        Notification.success(res.message || intl.formatMessage({ id: 'IDS_SEND_OTP_SUCCESS' }));
        if (isForgotPassword === true) {
          setStep(2);
        } else {
          setStep(1);
        }
      } else {
        Notification.error(res.message || intl.formatMessage({ id: 'IDS_TV_LOI_OTP' }));
      }
    }, (res) => {
      Notification.error(res.message || intl.formatMessage({ id: 'IDS_TV_LOI_OTP' }));
    });
  }

  const changePassword = () => {
    const data = {
      otp: otp,
      msisdn: phoneNumber,
      password: md5Hex(newPassword)
    };

    UserService.missPassword(data, res => {
      if (res.error_code === '0') {
        Notification.success(intl.formatMessage({ id: 'IDS_TV_DOI_MAT_KHAU_THANH_CONG' }));
        closeModalLogin();
        return;
      }

      let err = '';
      if (res.orgin_msg) {
        const msg = JSON.parse(res.orgin_msg);
        if (msg[0] && msg[0].AUTH_DESC) {
          err = msg[0].AUTH_DESC;
        }
      }
      const errs = err || intl.formatMessage({ id: 'IDS_TV_LOI_OTP' });
      setOpenModal(true);
      setContent(errs);
    });
  }

  const handlePhoneNumber = (value) => {
    setPhoneNumber(value)
    const test = regexPhoneNumber.test(value);
    if (!test || value.length > 11) {
      setErrorMsg(intl.formatMessage({ id: 'IDS_ERROR_ISDN_LONG' }));
    } else {
      setErrorMsg('');
    }
  }

  const handleContinue = () => {
    if (!isDisabled()) {
      sendOTP();
    }
  }

  // STEP = 0
  const confirmPasswordScreen = () => {
    return (
      <div className="position-relative">
        <FontAwesomeIcon
          color="#007bff"
          icon={faMobileAlt}
          size="2x"
          className="login__icon-mobile"
        />
        <InputText
          value={phoneNumber}
          handleOnChange={handlePhoneNumber}
          extensionClass="login__input-text"
          placeholder={intl.formatMessage({ id: 'IDS_TV_REQUEST_PHONE_NUMBER' })}
          errorMsg={errorMsg}
          onlyNumber
          onEnter={handleContinue}
        />
        <Button disabled={isDisabled()} className="login__btn mt-5"
          onClick={handleContinue}><FormattedMessage id='IDS_TV_NEXT' /></Button>
      </div>
    );
  }

  // STEP = 1
  const registerScreen = () => {
    const phoneSlice = phoneNumber?.slice(0, -3) + 'xxx';
    return (
      <div>
        <div className="phone-icon">
          <img alt="phone" src={telephone} />
          <span>{phoneSlice}</span>
        </div>
        <InputText
          value={otp}
          handleOnChange={(value) => setOtp(value)}
          extensionClass="login__input-text"
          placeholder={intl.formatMessage({ id: 'IDS_TV_NHAP_OTP' })}
          onlyNumber
        />
        <div className="pointer login__by-pass mt-3" onClick={sendOTP}>
          <FormattedMessage id='IDS_TV_FORM_REOTP' /></div>

        <div className="position-relative mt-3">
          <FontAwesomeIcon
            color="#007bff"
            icon={faLock}
            size="lg"
            className="login__icon-lock"
          />
          <InputText
            value={password}
            handleOnChange={handlePassword}
            extensionClass="login__input-text"
            placeholder={intl.formatMessage({ id: 'IDS_VPLUS_SIGNUP_PASSWORD' })}
            errorMsg={errorMsg}
            isPassword
          />
        </div>
        <br />
        <div className="position-relative">
          <FontAwesomeIcon
            color="#007bff"
            icon={faLock}
            size="lg"
            className="login__icon-lock"
          />
          <InputText
            value={rePassword}
            handleOnChange={handleRePassword}
            extensionClass="login__input-text"
            placeholder={intl.formatMessage({ id: 'IDS_SRENEWPASSWORD' })}
            isPassword
            errorMsg={errorMsg2}
          />
        </div>
        <InputRadio
          value={term}
          title={intl.formatMessage({ id: 'IDS_TV_REGISTER_PAY_TEMP' })}
          customClass="margin-top-20 open-wallet"
          handleOnChange={() => setTerm(!term)}
          selectedOption
        />
        <Button className="login__btn mt-4" disabled={isDisabledRegister()}
          onClick={handleRegister}><FormattedMessage id='IDS_TV_REGISTER_BUTTON' /></Button>
        <div className="login__term"><FormattedMessage id='IDS_SDKSD' /></div>
      </div>
    )
  }

  return (
    <>
      {step === 0 && confirmPasswordScreen()}
      {step === 1 && registerScreen()}
      {step === 2 &&
        <ResetPassword
          otp={otp}
          setOtp={setOtp}
          newPassword={newPassword}
          setNewPassword={setNewPassword}
          renewPassword={renewPassword}
          setRenewPassword={setRenewPassword}
          changePassword={changePassword}
          intl={intl}
        />
      }

      <KCSModal
        isOpenModal={isOpenModal}
        title={intl.formatMessage({ id: 'IDS_VPLUS_ALERT_TXT' })}
        content={content}
        closeModal={() => setOpenModal(false)}
      />
    </>
  );
}

export default React.memo(Signup);
